import React, { useContext, useState, useEffect } from "react";
import { Container, Nav, Navbar, Dropdown } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FaRegUser, FaRegHeart, FaUser } from "react-icons/fa6";
import { FaSignInAlt, FaCalendarCheck, FaSignOutAlt, FaChevronDown } from "react-icons/fa";

import { TiDocumentText } from "react-icons/ti";
import { IoLogOutOutline } from "react-icons/io5";
import techtricks from "../../assets/techtricks.png";
import { UserContext } from "../../context/UserContext";
import { toast } from "react-toastify";
import "./header.css";
import { Services, Subservices } from "../../env/action";
import { useNavigate } from "react-router-dom";
import MultiLevelDropdown from 'react-multilevel-dropdown';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData, setUserData, setServiceid, setServicename, setToken } =
    useContext(UserContext);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [services, setServices] = useState([]);
  const [subservices, setSubservices] = useState({});
  const [loadingSubId, setLoadingSubId] = useState(null);

  const doSomething = () => {
    console.log('Item 1 clicked');
  };
  const handleLogout = () => {
    setUserData(null);
    setToken(null);
    localStorage.clear();
    toast.success("Logged out user successfully!");
    navigate("/");
  };

  useEffect(() => {
    Services((res) => {
      if (res.status === 1) {
        setServices(res.data);
      } else {
        console.log("No services found");
      }
    });
  }, []);

  const handleServiceHover = (service) => {
    const serviceId = service.id;
    if (subservices[serviceId]) return;
    setLoadingSubId(serviceId);

    Subservices({ service_id: serviceId }, (res) => {
      if (res.status === 1) {
        setSubservices((prev) => ({ ...prev, [serviceId]: res.data }));
      } else {
        setSubservices((prev) => ({ ...prev, [serviceId]: [] }));
      }
      setLoadingSubId(null);
    });
  };


  return (
    <Navbar
      expand="lg"
      className="bg-body-tertiary border shadow header-conatiner"
    >
      <Container fluid className="hed">
        <Navbar.Brand>
          <Link to="/">
            {/* <img alt="logo" src={techtricks} width="95px" height="78px" className="headerimg p-0" /> */}
            <img alt="logo" src={techtricks} className="headerimg p-0" />
          </Link>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto nvsec">
            <NavLink
              exact
              to="/"
              className="nav-link"
              style={{
                color:
                  location.pathname === "/"
                    ? "rgb(20, 99, 243)"
                    : "var(--bs-nav-link-color)",
              }}
            >
              Home
            </NavLink>

            <MultiLevelDropdown
              title={
                <span className="d-flex bg-transparent align-items-center gap-1">
                  Services <FaChevronDown style={{ fontSize: "8px" }} />
                </span>
              }
              buttonClassName="bg-transparent shadow-none border-none hedbtn"
            >
              {services.map((service) => (
                <MultiLevelDropdown.Item
                  key={service.id}
                  onMouseEnter={() => handleServiceHover(service)}
                  onClick={() => {
                    if (
                      (!subservices[service.id] || subservices[service.id].length === 0) &&
                      service.web_screen_name
                    ) {
                      navigate(`/${service.web_screen_name}`);
                    }
                  }}
                >
                  {service.service_name}

                  {subservices[service.id]?.length > 0 && (
                    <MultiLevelDropdown.Submenu className="multi-level-dropdown-submenu">
                      {loadingSubId === service.id ? (
                        <MultiLevelDropdown.Item>Loading...</MultiLevelDropdown.Item>
                      ) : (
                        subservices[service.id].map((sub) => (
                          <MultiLevelDropdown.Item key={sub.id}>
                            <Link
                              to={`/${sub.web_screen_name}/${sub.subservice_id}`}
                              className="text-decoration-none text-dark"
                             onClick={() => {
                              localStorage.setItem(
                                "selectedSubserviceName",
                                sub.subservice_name
                              );

                              localStorage.setItem(
                                "service_id",
                                service.id
                              );

                              localStorage.setItem(
                                "subservice_id",
                                sub.subservice_id
                              );
                            }}
                            >
                              {sub.subservice_name}
                            </Link>
                          </MultiLevelDropdown.Item>
                        ))
                      )}
                    </MultiLevelDropdown.Submenu>
                  )}
                </MultiLevelDropdown.Item>
              ))}
            </MultiLevelDropdown>

            <MultiLevelDropdown
              title={
                <span className="d-flex align-items-center gap-1">
                  Hospital Staffing Services <FaChevronDown style={{ fontSize: "8px" }} />
                </span>
              }
              buttonClassName="bg-transparent shadow-none border-none hedbtn"
            >



              <MultiLevelDropdown.Item>
                <Link to="/nursingservice/MedicalStaffingService" className="text-decoration-none text-dark">
                  Medical Staffing Service
                </Link>
              </MultiLevelDropdown.Item>
              <MultiLevelDropdown.Item>
                <Link to="/nursingservice/RpoAndManpowerService" className="text-decoration-none text-dark">
                  RPO & Manpower Services
                </Link>
              </MultiLevelDropdown.Item>
              <MultiLevelDropdown.Item>
                <Link to="/facilitymanagementservice" className="text-decoration-none text-dark">
                  Facility Management Services
                </Link>
              </MultiLevelDropdown.Item>
              <MultiLevelDropdown.Item>
                <Link to="/nursinghelpdesk" className="text-decoration-none text-dark">
                  Nursing Help Desk
                </Link>
              </MultiLevelDropdown.Item>



            </MultiLevelDropdown>



            <NavLink
              exact
              to="/elder-care-services"
              className="nav-link"
              style={{
                color:
                  location.pathname === "/elder-care-services"
                    ? "rgb(20, 99, 243)"
                    : "var(--bs-nav-link-color)",
              }}
            >
              Elder Care Services
            </NavLink>

            <NavLink
              exact
              to="/companypage"
              className="nav-link"
              style={{
                color:
                  location.pathname === "/companypage"
                    ? "rgb(20, 99, 243)"
                    : "var(--bs-nav-link-color)",
              }}
            >
              Company
            </NavLink>
            <NavLink
              exact
              to="/membership"
              className="nav-link"
              style={{
                color:
                  location.pathname === "/membership"
                    ? "rgb(20, 99, 243)"
                    : "var(--bs-nav-link-color)",
              }}
            >
              Membership
            </NavLink>
            <NavLink
              exact
              className="nav-link"
              onClick={handleShow}
              style={{ color: "var(--bs-nav-link-color)" }}
            >
              Need Help
            </NavLink>

            <NavLink
              exact
              to="/book-a-surgery"
              className="boksurgery"
              style={{
                color:
                  location.pathname === "/companypage"
                    ? "rgb(20, 99, 243)"
                    : "#0d6efd",
              }}
            >
              Book a Surgery
            </NavLink>
          </Nav>

          <Dropdown className="nav-link my-2">
            {userData ? (
              <Dropdown.Toggle className="d-flex align-items-center fs-12 p-2 btn-primary">

                <>
                  <img
                    src={userData.image}
                    alt="Profile"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      marginRight: "8px",
                    }}
                  />
                  <span className="loginame">
                    {userData.name}
                  </span>
                </>
              </Dropdown.Toggle>
            ) : (
              <div className="header-auth-buttons d-flex gap-2 px-3 pb-2">
                <Link to="/login" className="btn">
                  Login
                </Link>
                <Link to="/registeruser" className="btn">
                  Sign Up
                </Link>
              </div>
            )}

            <Dropdown.Menu align="start">
              {userData ? (
                <>
                  <Dropdown.Item as={NavLink} to="/myprofile">
                    <FaRegUser className="me-2" /> My Profile
                  </Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="/appointments">
                    <TiDocumentText className="me-2" /> Appointments
                  </Dropdown.Item>
                  <Dropdown.Item as={NavLink} to="#" onClick={handleLogout}>
                    <IoLogOutOutline className="me-2" /> Logout
                  </Dropdown.Item>
                </>
              ) : (
                <div className="sumo">
                  <Dropdown.Item as={NavLink} to="/login">
                    <FaSignInAlt className="me-2" /> Login
                  </Dropdown.Item>
                </div>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
